import { useRef, useState } from "react";
import RecessImage from "../../../Assets/Images/p1.png";
import RecessImageTwo from "../../../Assets/Images/p2.png";
import RecessImageThree from "../../../Assets/Images/p3.png";
import {
  MEDIA_LINKS,
  COMMON_THUMBNAIL_URL,
} from "../../../Constants/mediaLinks";
import recess from "../../../Assets/Images/recess.png";
import recessMobile from "../../../Assets/Images/recess-mobile.png";
import "./recess.css";

const Recess = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  // console.log("added", RecessImageThree);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
  };
  return (
    <div className="recess">
      <div className="recess-heading">
        <div className="new-img-border">
          <img className="recess-desktop" src={recess} alt="recess-img" />
          <img
            className="recess-mobile"
            src={recessMobile}
            alt="recess-mobile"
          />
          {/* <h2>Recess</h2>
        <div className="recess-images">
          <img src={RecessImage} alt="recess" />
          <img src={RecessImageTwo} alt="recess" />
          <img src={RecessImageThree} alt="recess" />
        </div> */}
        </div>
      </div>

      <div className="recess-video">
        <div className="recess-video-content">
          <p className="black-text-clip">
            Our goal is to provide students with a break from classroom
            activities, allowing them to engage in physical exercise, social
            interaction, and structured play in a safe and supervised
            environment.
          </p>
          <div className="prgrm-cmpt">
            <p className="black-text-clip">Program Components:</p>
            <ul className="black-text-clip">
              <li>Organized Games</li>
              <li> Creative Play Areas</li> <li> Quiet Zones</li>
              <li>Social Interaction</li>
              <li> Safety & Supervision</li>
            </ul>
          </div>
        </div>

        <div className="video-container">
          <div className="recess-video-child">
            <video
              controls
              autoPlay
              muted
              poster={MEDIA_LINKS.SCHOOL_PROGRAMS.VIDEO_01}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            >
              <source
                src={MEDIA_LINKS.SCHOOL_PROGRAMS.VIDEO_01}
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Recess;
